import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { BaseService } from 'src/app/services';
import { throttleTime } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ProductsService extends BaseService {
  managementStatus = new Subject<any>();
  historyChange = new Subject<any>();
  currentManagementStatus = this.managementStatus.asObservable();
  currentHistoryChange = this.historyChange.asObservable();

  getManagementStatus(status: any) {
    this.managementStatus.next(status);
  }

  getHistoryChange(data: any) {
    console.log('data sj: ', data);
    this.historyChange.next(data);
  }
  getAll(query?: any): Observable<any> {
    return this.get<any>('/product', { params: query }).pipe(throttleTime(500));
  }

  getAllProduct(query?: any): Observable<any> {
    return this.get<any>('/product/short', { params: query });
  }

  getAllProductManaged(query?: any): Observable<any> {
    return this.get<any>('/product/search/managed', { params: query });
  }

  getAllProductByShop(query?: any): Observable<any> {
    return this.get<any>('/shop/product/search', { params: query });
  }

  getAllManagementStatus(query?: any): Observable<any> {
    return this.get<any>('/product/management-status', { params: query });
  }

  getById(id: string): Observable<any> {
    return this.get<any>(`/product/info?product_id=${id}`);
  }

  getAllSubscription(query?: any): Observable<any> {
    return this.get<any>('/subscription/active', { params: query });
  }

  getAllSubscription2(query?: any): Observable<any> {
    return this.get<any>('/subscription/short', { params: query });
  }

  create(body: any): Observable<any> {
    return this.post2<any>(`/product/add`, body);
  }
  createV1(body: any): Observable<any> {
    return this.post<any>(`/product/add`, body);
  }
  update(id: string, body: any): Observable<any> {
    return this.put<any>(`/product/info?product_id=${id}`, body);
  }

  // tslint:disable-next-line:variable-name
  importFile(
    id: string,
    body: any,
    is_check_gln: boolean,
    is_validate_gtin: boolean
  ): Observable<any> {
    return this.post<any>(
      `/product/add/upload?sub_id=${id}&is_check_gln=${is_check_gln}&is_validate_gtin=${is_validate_gtin}`,
      body
    );
  }

  destroy(id: string): Observable<any> {
    return this.delete2<any>(`/product?product_ids=${id}`);
  }

  hidden(isHidden: boolean, product_ids: any): Observable<any> {
    return this.put<any>(
      `/product/hidden?isHidden=${isHidden}&product_ids=${product_ids}`
    );
  }

  exportExcel(query?: any): Observable<any> {
    const httpOptions = {
      params: query,
      responseType: 'blob',
    };
    return this.get<any>('/product/export', httpOptions);
  }
  getProductRelated(query?: any): Observable<any> {
    return this.get<any>('/product/search/managed', { params: query });
  }
  updateProductFromExcel(query?: any, body?: any) {
    return this.post<any>('/product/info/upload', body, { params: query });
  }
  deleteFlashProductByBarcode(body?: any) {
    // console.log(body);
    return this.delete<any>('/product/barcode', body);
  }

  getListHistory(query: any): Observable<any> {
    return this.get<any>('/product/info/request', { params: query });
  }

  getCompareDetail(id: any): Observable<any> {
    return this.get<any>('/product/info/request/' + id);
  }

  getBagdes(query?: any): Observable<any> {
    return this.get<any>('/bagde/bagdes', { params: query });
  }

  getPassportByDocument(userId, productId, query?: any): Observable<any> {
    return this.get<any>(`/passport/product-passport/${userId}/${productId}/document-type`, { params: query });
  }

  getPassports(query?: any): Observable<any> {
    return this.get<any>(`/passport/passports`, { params: query });
  }

  getProductPassport(userId, productId) {
    return this.get<any>(`passport/product-passport/${userId}/${productId}`, {});
  }

  getELabel(productId: any): Observable<any> {
    return this.get<any>(`/e-labels/${productId}`);
  }

  deleteELabel(productId: any): Observable<any> {
    return this.delete<any>(`/e-labels/${productId}`);
  }

  upsertELabel(productId: any, body: any): Observable<any> {
    return this.put<any>(`/e-labels/${productId}`, body);
  }

  getELabelLogs(productId: any, query?: any): Observable<any> {
    return this.get<any>(`/e-labels/${productId}/logs`, { params: query });
  }

  getELabelLogDetail(productId: any, logId: any): Observable<any> {
    return this.get<any>(`/e-labels/${productId}/logs/${logId}`);
  }

  getELabelAttributes(query?: any): Observable<any> {
    return this.get<any>(`/attributes`, { params: query });
  }

  getELabelAttributeSets(query?: any): Observable<any> {
    return this.get<any>(`/attributes-sets`, { params: query });
  }
}
